import React, { useEffect, useState } from 'react';
import './ChargerSiteCard.css';
import image from '../../assets/charger-station-image.png';
import imageLocation from '../../assets/Location.svg';
import { ReactComponent as ImageThunderBlue } from '../../assets/thunders/thunder_blue_vector.svg';
import imageThunderGreen from '../../assets/thunder_green.svg';
import imageThunderWhite from '../../assets/thunder_white.svg';
import imageRoaming from '../../assets/world_roaming_icon.svg';
import { formatCmcType, formatKm } from '../../utils/format';
import { getFile } from '../../services/chargerSitesServices';
import { ReactComponent as Loader } from '../../assets/SpinnerBlack.svg';
import { useBrandContext } from '../../context/BrandContext';
import { AVAILABILITY_NOT_INFORMED, dataSourceOf, isInformationalSite } from '../../utils/sitePinType';

type ChargerSiteCardProps = {
  chargerSite: any;
  userDistance: number;
  appBgFile: string | null;
  onClick: React.MouseEventHandler<HTMLDivElement>;
  loadingAppBgFile?: boolean;
};

const ChargerSiteCard: React.FC<ChargerSiteCardProps> = ({
  chargerSite,
  userDistance,
  appBgFile,
  onClick,
  loadingAppBgFile,
}) => {
  const {
    csName,
    csFormattedAddress,
    distanceMeters,
    chargerSiteStatus,
    cmcType,
    csPrivate,
    isOcpi = false,
  } = chargerSite;
  const [loading, setLoading] = useState(false);
  const [csImage, setCsImage] = useState<any>('');
  const [error, setError] = useState('');
  const brandContext = useBrandContext();

  useEffect(() => {
    const fetchChargerBgFile = async (fileId: string) => {
      setLoading(true);
      try {
        const csBgFile = await getFile(fileId);
        setCsImage(csBgFile?.fileData);
      } catch (error) {
        console.error('Erro ao buscar sites de carregamento', error);
        setError('Erro ao buscar sites de carregamento');
      }
      setLoading(false);
    };
    if (chargerSite.csBgFileId) {
      fetchChargerBgFile(chargerSite.csBgFileId);
    } else if (brandContext.appBgFileId) {
      setCsImage(appBgFile);
    }
  }, [chargerSite.csBgFileId, appBgFile]);

  let total_status_icons = 6;

  const icon_available_count =
    chargerSiteStatus.available > total_status_icons
      ? total_status_icons
      : chargerSiteStatus.available;
  total_status_icons =
    total_status_icons - icon_available_count < 0
      ? 0
      : total_status_icons - icon_available_count;

  const icon_inUse_count =
    chargerSiteStatus.inUse > total_status_icons
      ? total_status_icons
      : chargerSiteStatus.inUse;
  total_status_icons =
    total_status_icons - icon_inUse_count < 0
      ? 0
      : total_status_icons - icon_inUse_count;

  const icon_offLine_count =
    chargerSiteStatus.offLine > total_status_icons
      ? total_status_icons
      : chargerSiteStatus.offLine;

  return (
    <div className='charger-card' onClick={onClick}>
      {!loading && !loadingAppBgFile ? (
        <img
          src={csImage ? csImage : image}
          alt={`${csName}`}
          className='charger-card-image'
        />
      ) : null}
      {loading || loadingAppBgFile ? (
        <Loader style={{ backgroundColor: 'transparent !important' }} />
      ) : null}
      <div className='charger-card-content'>
        <h2 className='charger-card-title'>
          {csName}{' '}
          {isOcpi && (
            <img
              className='world-roaming-icon'
              loading='lazy'
              alt='roaming-icon'
              src={imageRoaming}
            />
          )}
        </h2>
        <div className='charger-card-chargers'>
          <span className='charger-card-chargers_text'>Carregadores </span>
          {isInformationalSite(chargerSite) ? (
            <span className='charger-card-chargers_text'>
              {AVAILABILITY_NOT_INFORMED}
              {dataSourceOf(chargerSite) && (
                <>
                  <br />
                  <small>{dataSourceOf(chargerSite)}</small>
                </>
              )}
            </span>
          ) : (
          <span className='charger-card-chargers_thunder'>
            {Array.from({ length: icon_available_count }).map((_, index) => (
              <img
                key={`available-${index}`}
                src={imageThunderGreen}
                className={'charger-icon charger-icon-green'}
                alt='Disponível'
              />
            ))}
            {Array.from({ length: icon_inUse_count }).map((_, index) => (
              <ImageThunderBlue
                key={`inUse-${index}`}
                width={9}
                height={13}
                className={'charger-icon charger-icon-blue'}
              />
            ))}
            {Array.from({ length: icon_offLine_count }).map((_, index) => (
              <img
                key={`offLine-${index}`}
                src={imageThunderWhite}
                className={'charger-icon charger-icon-white'}
                alt='Não disponível'
              />
            ))}
          </span>
          )}
        </div>
        {(cmcType || csPrivate) && (
          <div className='charger-card-ac-dc-type'>
            <span>
              {cmcType ? `${formatCmcType(cmcType)} • ` : ''}{' '}
              {csPrivate ? 'Privado' : 'Público'}
            </span>
          </div>
        )}
        <div className='charger-card-location'>
          <img
            src={imageLocation}
            alt='site-brand'
            className='charger-card-location-icon'
          />
          <span>
            {' '}
            <b>{formatKm(userDistance)} km </b> - {csFormattedAddress}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ChargerSiteCard;
